import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from "@mui/styles";
import { Table, TableHead, TableBody, TableCell, TableContainer, TableRow, TablePagination, Collapse, Select, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { metisUserTableColumns } from '../../../Config/constants';
import MetisUserDialog from '../../Shared/Dialogs/User/MetisUserDialog';
import { toast } from 'react-toastify';
import { Spin } from "react-cssfx-loading";
import { connect } from 'react-redux';
import { Check, EllipsisVertical, Search, X, ChevronUp, ChevronDown, MoreHorizontal } from 'lucide-react';
import ScanBadgeDialog from '../../Shared/Dialogs/ScanBadgeDialog';
import DeleteDialog from '../../Shared/Dialogs/User/DeleteDialog';
import { dataService } from '../../../Services/data/data.service';

export const MetisUsersOverviewTable = (props) => {
    const classes = useStyles();

    const [selectedUser, setSelectedUser] = useState(null);
    const [editingUser, setEditingUser] = useState(false);
    const [deletingUser, setDeletingUser] = useState(false);
    const [scanningBadge, setScanningBadge] = useState(false);

    const { t } = useTranslation();
    const [pg, setpg] = useState(0);
    const [rpg, setrpg] = useState(25);
    const [dropdownItem, setDropdownItem] = useState(null);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [localUsers, setLocalUsers] = useState([]);
    const [filterValues, setFilterValues] = useState([
        { type: metisUserTableColumns.ID, value: "", groupingUp: false, groupingDown: false },
        { type: metisUserTableColumns.NAME, value: "", groupingUp: false, groupingDown: false },
        { type: metisUserTableColumns.EMAIL, value: "", groupingUp: false, groupingDown: false },
        { type: metisUserTableColumns.ROLE, value: "", groupingUp: false, groupingDown: false },
        { type: metisUserTableColumns.FEATURE, value: "", groupingUp: false, groupingDown: false },
        { type: metisUserTableColumns.BADGENUMBER, value: "", groupingUp: false, groupingDown: false }
    ]);

    const [userRoles, setUserRoles] = useState([]);
    const [userFeatures, setUserFeatures] = useState([]);

    const dropdownRef = useRef(null);

    useEffect(() => {
        
        if (localUsers.length === 0) {
            let tempUsers = props.users.map(x => ({
                ...x,
                visible: true
            }));
            setLocalUsers(tempUsers);
            setFilteredUsers(tempUsers);
        } else if (props.users.length !== localUsers.length) {
            console.log("new users")
            let tempUsers = props.users.map(x => ({
                ...x,
                visible: true
            }));
            setLocalUsers(tempUsers);
            setFilteredUsers(tempUsers);
            
            filterAndGroupUsers(filterValues, tempUsers);
        }
        // filterAndGroupUsers(filterValues);
    }, [props.users]);

    useEffect(() => {
        setUserRoles(props.userRoles);
    }, [props.userRoles]);

    useEffect(() => {
        setUserFeatures(props.userFeatures);
    }, [props.userFeatures]);

    useEffect(() => {
        if (!props.showFilters) {
            handleRemoveFilters();
        }
    }, [props.showFilters]);

    const handleUserUpdate = (user) => {
        user.visible = true;
        let tempUsers = [...localUsers];
        let index = tempUsers.findIndex(x => x.Id === user.Id);
        tempUsers[index] = user;
        setLocalUsers(tempUsers);
        filterAndGroupUsers(filterValues, tempUsers);
        props.updateMetisUserLocally(user);
    }

    function handleChangePage(event, newpage) {
        setpg(newpage);
    }

    function handleChangeRowsPerPage(event) {
        setrpg(parseInt(event.target.value));
        setpg(0);
    }

    const handleToggleDropdown = (id) => {
        if (dropdownItem) {
            setDropdownItem(null);
            return;
        }
        setDropdownItem(id);

    }

    const handleClickOutsideDropdown = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setTimeout(() => {
                setDropdownItem(null);
            }, 100);
        }
    };

    useEffect(() => {
        if (dropdownItem) {
            document.addEventListener('mousedown', handleClickOutsideDropdown);
        } else {
            document.removeEventListener('mousedown', handleClickOutsideDropdown);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutsideDropdown);
        };
    }, [dropdownItem]);

    const formatBoolean = (value) => {
        if (value) {
            return (
                <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <Check size={20} color="#5CC958"></Check>
                    <p style={{ margin: "0", color: "#5CC958" }}>{t("Badge assigned")}</p>
                </div>
            )
        } else {
            return (
                <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <X size={20} color="#D84949"></X>
                    <p style={{ margin: "0", color: "#D84949" }}>{t("No badge assigned")}</p>
                </div>
            )
        }
    }

    const formatRole = (role) => {
        switch (role) {
            case "Operator":
                return (
                    <div key={role.Id} style={{ display: "flex", alignItems: "center", backgroundColor: "#DEE8FF", color: "#4654FB", width: "fit-content", padding: "4px 12px", borderRadius: "30px", fontSize: "14px" }}>
                        {t("Operator")}
                    </div>
                );
            case "Admin":
                return (
                    <div key={role.Id} style={{ display: "flex", alignItems: "center", backgroundColor: "#FBE5E5", color: "#D84949", width: "fit-content", padding: "4px 12px", borderRadius: "30px", fontSize: "14px" }}>
                        {t("Admin")}
                    </div>
                );
            default:
                return (
                    <div key={role.Id} style={{ display: "flex", alignItems: "center", backgroundColor: "#DEE8FF", color: "#4654FB", width: "fit-content", padding: "4px 12px", borderRadius: "30px", fontSize: "14px" }}>
                        {t(role)}
                    </div>
                );
        }
    }

    const RoleDisplay = ({ row }) => {
        const sortedRoles = [...row.Roles].sort((a, b) => a.Name.localeCompare(b.Name));
        const rolesToShow = sortedRoles.slice(0, 3);
        const hasMoreRoles = row.Roles.length > 3;
        const hasNoRoles = row.Roles.length === 0;

        return (
            <div key={row.Id} style={{ display: "flex", gap: "8px" }}>
                {rolesToShow.map((role, index) => (
                    formatRole(role.DisplayName)
                ))}
                {hasMoreRoles && (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#DEE8FF", color: "#4654FB", width: "fit-content", height: "28px", width: "28px", borderRadius: "30px", fontSize: "14px" }}>
                        <MoreHorizontal size={16} color="#4654FB" />
                    </div>
                )}
                {hasNoRoles && (
                    "-"
                )}
            </div>
        );
    };

    const FeatureDisplay = ({ row }) => {
        const sortedFeatures = [...row.Features].sort((a, b) => a.DisplayName.localeCompare(b.DisplayName));
        const featuresToShow = sortedFeatures.slice(0, 3);
        const hasMoreFeatures = row.Features.length > 3;
        const hasNoFeatures = row.Features.length === 0;

        return (
            <div style={{ display: "flex", gap: "8px" }}>
                {featuresToShow.map((feature, index) => (
                    <div key={index} style={{ display: "flex", alignItems: "center", backgroundColor: "#DEE8FF", color: "#4654FB", width: "fit-content", padding: "4px 12px", borderRadius: "30px", fontSize: "14px" }}>
                        {t(feature.DisplayName)}
                    </div>
                ))}
                {hasMoreFeatures && (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#DEE8FF", color: "#4654FB", width: "fit-content", height: "28px", width: "28px", borderRadius: "30px", fontSize: "14px" }}>
                        <MoreHorizontal size={16} color="#4654FB" />
                    </div>
                )}
                {hasNoFeatures && (
                    "-"
                )}
            </div>
        );
    };

    const getGroupingIconColor = (type, up) => {
        if (filterValues.some(x => x.type === type)) {
            if (up) {
                if (filterValues.find(x => x.type === type).groupingUp) {
                    return "#4654FB";
                }
            }
            else {
                if (filterValues.find(x => x.type === type).groupingDown) {
                    return "#4654FB";
                }
            }
        }
        return "rgba(12, 14, 41, .6)";
    }

    const getGroupingIconSize = (type, up) => {
        if (filterValues.some(x => x.type === type)) {
            if (up) {
                if (filterValues.find(x => x.type === type).groupingUp) {
                    return 16;
                }
            }
            else {
                if (filterValues.find(x => x.type === type).groupingDown) {
                    return 16;
                }
            }
        }
        return 12;
    }

    const searchScannedBadge = (badgeNumber) => {
        handleSearch(badgeNumber, metisUserTableColumns.BADGENUMBER);
    };

    const handleRemoveFilters = () => {
        let tempUsers = props.users.map(x => ({
            ...x,
            visible: true
        }));

        setFilterValues([
            { type: metisUserTableColumns.ID, value: "", groupingUp: false, groupingDown: false },
            { type: metisUserTableColumns.NAME, value: "", groupingUp: false, groupingDown: false },
            { type: metisUserTableColumns.EMAIL, value: "", groupingUp: false, groupingDown: false },
            { type: metisUserTableColumns.ROLE, value: "", groupingUp: false, groupingDown: false },
            { type: metisUserTableColumns.FEATURE, value: "", groupingUp: false, groupingDown: false },
            { type: metisUserTableColumns.BADGENUMBER, value: "", groupingUp: false, groupingDown: false }
        ])

        setFilteredUsers(tempUsers);
    }

    const clearFilter = (column) => {
        let tempFilterValues = [...filterValues];

        tempFilterValues.find(x => x.type === column).value = "";

        let filterPresent = false;

        tempFilterValues.map(filterValue => {
            if (filterValue.value && filterValue.value.toString() !== null && (filterValue.value.length > 0 || filterValue.value == true)) {
                filterPresent = true;
            }
        })

        if (!filterPresent) {
            tempFilterValues = [
                { type: metisUserTableColumns.ID, value: "", groupingUp: false, groupingDown: false },
                { type: metisUserTableColumns.NAME, value: "", groupingUp: false, groupingDown: false },
                { type: metisUserTableColumns.EMAIL, value: "", groupingUp: false, groupingDown: false },
                { type: metisUserTableColumns.ROLE, value: "", groupingUp: false, groupingDown: false },
                { type: metisUserTableColumns.FEATURE, value: "", groupingUp: false, groupingDown: false },
                { type: metisUserTableColumns.BADGENUMBER, value: "", groupingUp: false, groupingDown: false }
            ]
        }

        filterAndGroupUsers(tempFilterValues);
        setFilterValues(tempFilterValues);
    }

    const handleSearch = (e, column) => {
        let value;

        value = e.target.value;

        let tempFilterValues = [...filterValues];

        if (tempFilterValues.some(x => x.type === column)) {
            tempFilterValues.find(x => x.type === column).value = value;
        } else {
            tempFilterValues.push({ type: column, value: value });
        }

        let filterPresent = false;

        tempFilterValues.map(filterValue => {
            if (filterValue.value && filterValue.value.toString() !== null && (filterValue.value.length > 0 || filterValue.value == true)) {
                filterPresent = true;
            }
        })

        if (!filterPresent) {
            tempFilterValues = [
                { type: metisUserTableColumns.ID, value: "", groupingUp: false, groupingDown: false },
                { type: metisUserTableColumns.NAME, value: "", groupingUp: false, groupingDown: false },
                { type: metisUserTableColumns.EMAIL, value: "", groupingUp: false, groupingDown: false },
                { type: metisUserTableColumns.ROLE, value: "", groupingUp: false, groupingDown: false },
                { type: metisUserTableColumns.FEATURE, value: "", groupingUp: false, groupingDown: false },
                { type: metisUserTableColumns.BADGENUMBER, value: "", groupingUp: false, groupingDown: false }
            ]
        }

        filterAndGroupUsers(tempFilterValues);
        setFilterValues(tempFilterValues);
    }

    const handleGrouping = (column, up) => {
        let tempFilterValues = [...filterValues];

        if (tempFilterValues.some(x => x.type === column)) {
            if (up) {
                // Check if already grouped up
                if (tempFilterValues.find(x => x.type === column).groupingUp) {
                    // Remove grouping if already grouped up
                    tempFilterValues.find(x => x.type === column).groupingUp = false;
                } else {
                    // Group up
                    tempFilterValues.find(x => x.type === column).groupingUp = true;
                    tempFilterValues.find(x => x.type === column).groupingDown = false;
                }
            } else {
                // Check if already grouped up
                if (tempFilterValues.find(x => x.type === column).groupingDown) {
                    // Remove grouping if already grouped down
                    tempFilterValues.find(x => x.type === column).groupingDown = false;
                } else {
                    // Group down
                    tempFilterValues.find(x => x.type === column).groupingDown = true;
                    tempFilterValues.find(x => x.type === column).groupingUp = false
                }
            }
        } else {
            tempFilterValues.push({ type: column, value: "", groupingUp: up, groupingDown: !up });
        }

        filterAndGroupUsers(tempFilterValues);
        setFilterValues(tempFilterValues);
    }

    const filterAndGroupUsers = (filterValues, userCollection) => {
        let tempUsers;
        if (userCollection) {
            tempUsers = JSON.parse(JSON.stringify(userCollection));
        } else {
            tempUsers = JSON.parse(JSON.stringify(localUsers));
        }

        filterValues.forEach(filterValue => {
            var value = filterValues.find(x => x.type === filterValue.type).value;
            switch (filterValue.type) {
                case metisUserTableColumns.ID:
                    if (value !== null && value !== "") {
                        tempUsers.map(x => { if (x.Id) { if (!x.Id.toString().toLowerCase().includes(value.toLowerCase())) { x.visible = false } } else { x.visible = false } })
                    }
                    if (filterValue.groupingUp) {
                        tempUsers.sort((a, b) => (a.Id > b.Id) ? 1 : -1);
                    }
                    if (filterValue.groupingDown) {
                        tempUsers.sort((a, b) => (a.Id < b.Id) ? 1 : -1);
                    }
                    break;
                case metisUserTableColumns.NAME:
                    if (value !== null && value !== "") {
                        tempUsers.map(x => { if (x.Name) { if (!x.Name.toString().toLowerCase().includes(value.toString().toLowerCase())) { x.visible = false; } } else { x.visible = false } });
                    }
                    if (filterValue.groupingUp) {
                        tempUsers.sort((a, b) => (a.Name.toLowerCase() > b.Name.toLowerCase()) ? 1 : -1);
                    }
                    if (filterValue.groupingDown) {
                        tempUsers.sort((a, b) => (a.Name.toLowerCase() < b.Name.toLowerCase()) ? 1 : -1);
                    }
                    break;
                case metisUserTableColumns.EMAIL:
                    if (value !== null && value !== "") {
                        tempUsers.map(x => { if (x.Email) { if (!x.Email.toString().toLowerCase().includes(value.toString().toLowerCase())) { x.visible = false; } } else { x.visible = false } });
                    }
                    if (filterValue.groupingUp) {
                        tempUsers.sort((a, b) => (a.Email > b.Email) ? 1 : -1);
                    }
                    if (filterValue.groupingDown) {
                        tempUsers.sort((a, b) => (a.Email < b.Email) ? 1 : -1);
                    }
                    break;
                case metisUserTableColumns.ROLE:
                    if (value) {
                        tempUsers.forEach(x => {
                            if (x.Roles.length === 0 || !x.Roles.some(role =>
                                role.Name && role.Name.toString().toLowerCase().includes(value.toString().toLowerCase())
                            )) {
                                x.visible = false;
                            }
                        });
                    }
                    if (filterValue.groupingUp) {
                        tempUsers.sort((a, b) => (a.Role > b.Role) ? 1 : -1);
                    }
                    if (filterValue.groupingDown) {
                        tempUsers.sort((a, b) => (a.Role < b.Role) ? 1 : -1);
                    }
                    break;
                case metisUserTableColumns.FEATURE:
                    if (value) {
                        tempUsers.forEach(x => {
                            if (x.Features.length === 0 || !x.Features.some(feature =>
                                feature.DisplayName &&
                                feature.DisplayName.toString().toLowerCase().includes(value.toString().toLowerCase())
                            )) {
                                x.visible = false;
                            }
                        });
                    }
                    if (filterValue.groupingUp) {
                        tempUsers.sort((a, b) => (a.Feature > b.Feature) ? 1 : -1);
                    }
                    if (filterValue.groupingDown) {
                        tempUsers.sort((a, b) => (a.Feature < b.Feature) ? 1 : -1);
                    }
                    break;
                case metisUserTableColumns.BADGENUMBER:
                    if (value !== null && value !== "" && value !== undefined) {
                        if (value === "assigned") {
                            tempUsers.map(x => { if (!x.Badgenumber) { x.visible = false; } });
                        } else if (value === "notAssigned") {
                            tempUsers.map(x => { if (x.Badgenumber) { x.visible = false; } });
                        } else {
                            tempUsers.map(x => {
                                if (x.Badgenumber) {
                                    if (x.Badgenumber.toString().toLowerCase() !== value.toString().toLowerCase()) {
                                        x.visible = false;
                                    }
                                } else {
                                    x.visible = false;
                                }
                            });
                        }
                    }
                    if (filterValue.groupingUp) {
                        tempUsers.sort((a, b) => (a.Badgenumber > b.Badgenumber) ? 1 : -1);
                    }
                    if (filterValue.groupingDown) {
                        tempUsers.sort((a, b) => (a.Badgenumber < b.Badgenumber) ? 1 : -1);
                    }
            }
        });
        setFilteredUsers(tempUsers);
    }

    const handleEditUser = (user) => {
        setDropdownItem(null);
        setSelectedUser(user);
        setEditingUser(true);
    }

    const closeEditDialog = () => {
        setSelectedUser(null);
        setEditingUser(false);
    }

    const handleDeleteUser = (user) => {
        setDropdownItem(null);
        setSelectedUser(user);
        setDeletingUser(true);
    }

    const closeDeleteDialog = () => {
        setSelectedUser(null);
        setDeletingUser(false);
    }

    const deleteUser = (userId) => {
        dataService.DeleteMetisUser(userId).then((response) => {
            closeDeleteDialog();
            
            if (response.ok) {
                props.setUpdatingMetisUsers(true);
            } else {
                toast.error(t("Error getting Metis users"), { position: "top-center" });
            }
        })
    }

    return (
        <React.Fragment>
            {props.loading ? <div className={classes.loadingBalls}><Spin width="48px" height="48px" color="#4654FB"></Spin></div> :
                <div className={classes.tableContainer}>
                    <React.Fragment>
                        <TableContainer className={classes.tableContainer}>
                            <Table className={classes.table} aria-label="customized table">
                                <TableHead className={classes.head}>
                                    {/* Filters */}
                                    <TableRow key='Metis_Filter_row' className={classes.head__filterRow}>
                                        <TableCell className={classes.head__filterCell}>
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                <div className={classes.head__filterInputContainer}>
                                                    <input className={classes.head__filterInput} type="text" value={filterValues[metisUserTableColumns.ID].value} onChange={(e) => handleSearch(e, metisUserTableColumns.ID)} />
                                                    <Search size={16} className={classes.head__filterInputIcon} />
                                                </div>
                                            </Collapse>
                                        </TableCell>
                                        <TableCell className={classes.head__filterCell} >
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                <div className={classes.head__filterInputContainer}>
                                                    <input className={classes.head__filterInput} type="text" value={filterValues[metisUserTableColumns.NAME].value} onChange={(e) => handleSearch(e, metisUserTableColumns.NAME)} />
                                                    <Search size={16} className={classes.head__filterInputIcon} />
                                                </div>
                                            </Collapse>
                                        </TableCell>
                                        {/* <TableCell className={classes.head__filterCell}>
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                <div className={classes.head__filterInputContainer}>
                                                    <input className={classes.head__filterInput} type="text" value={filterValues[metisUserTableColumns.EMAIL].value} onChange={(e) => handleSearch(e, metisUserTableColumns.EMAIL)} />
                                                    <Search size={16} className={classes.head__filterInputIcon} />
                                                </div>
                                            </Collapse>
                                        </TableCell> */}
                                        <TableCell className={classes.head__filterCell}>
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                <Select
                                                    value={filterValues[metisUserTableColumns.ROLE].value}
                                                    onChange={(e) => handleSearch(e, metisUserTableColumns.ROLE)}
                                                    displayEmpty
                                                    className={classes.head__filterSelect}
                                                    sx={{
                                                        '.MuiOutlinedInput-notchedOutline': {
                                                            border: "none",
                                                        },
                                                        '& .MuiSelect-select': {
                                                            padding: 0,
                                                            border: 'none',
                                                        },
                                                    }}
                                                    MenuProps={{
                                                        classes: { paper: classes.menu },
                                                        anchorOrigin: {
                                                            vertical: "bottom",
                                                            horizontal: "left"
                                                        },
                                                        transformOrigin: {
                                                            vertical: "top",
                                                            horizontal: "left"
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value="">{t("All")}</MenuItem>
                                                    {userRoles.map((role) => (
                                                        <MenuItem key={role.Id} value={role.Name}>{t(role.Name)}</MenuItem>
                                                    ))}
                                                </Select>
                                            </Collapse>
                                        </TableCell>
                                        <TableCell className={classes.head__filterCell}>
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                <Select
                                                    value={filterValues[metisUserTableColumns.FEATURE].value}
                                                    onChange={(e) => handleSearch(e, metisUserTableColumns.FEATURE)}
                                                    displayEmpty
                                                    className={classes.head__filterSelect}
                                                    sx={{
                                                        '.MuiOutlinedInput-notchedOutline': {
                                                            border: "none",
                                                        },
                                                        '& .MuiSelect-select': {
                                                            padding: 0,
                                                            border: 'none',
                                                        },
                                                    }}
                                                    MenuProps={{
                                                        classes: { paper: classes.menu },
                                                        anchorOrigin: {
                                                            vertical: "bottom",
                                                            horizontal: "left"
                                                        },
                                                        transformOrigin: {
                                                            vertical: "top",
                                                            horizontal: "left"
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value="">{t("All")}</MenuItem>
                                                    {userFeatures.map((feature) => (
                                                        <MenuItem key={feature.Id} value={feature.DisplayName}>{t(feature.DisplayName)}</MenuItem>
                                                    ))}
                                                </Select>
                                            </Collapse>
                                        </TableCell>
                                        <TableCell className={classes.head__filterCell}>
                                            <Collapse in={props.showFilters} timeout={200} className={classes.head__collapse}>
                                                {!["", "assigned", "notAssigned"].includes(filterValues[metisUserTableColumns.BADGENUMBER].value) ?
                                                    <div className={classes.head__filterInputContainer}>
                                                        <div className={classes.head__fakeFilterInput} type="text" value={filterValues[metisUserTableColumns.BADGENUMBER].value} onChange={(e) => handleSearch(e, metisUserTableColumns.BADGENUMBER)}>
                                                            <p>{t("Badge scanned")}</p>
                                                        </div>
                                                        <button className={classes.head__filterInputButton} onClick={() => clearFilter(metisUserTableColumns.BADGENUMBER)}>
                                                            <X size={16} />
                                                        </button>
                                                    </div>
                                                    :
                                                    <Select
                                                        value={filterValues[metisUserTableColumns.BADGENUMBER].value}
                                                        onChange={(e) => handleSearch(e, metisUserTableColumns.BADGENUMBER)}
                                                        displayEmpty
                                                        className={classes.head__filterSelect}
                                                        sx={{
                                                            '.MuiOutlinedInput-notchedOutline': {
                                                                border: "none",
                                                            },
                                                            '& .MuiSelect-select': {
                                                                padding: 0,
                                                                border: 'none',
                                                            },
                                                        }}
                                                        MenuProps={{
                                                            classes: { paper: classes.menu },
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "left"
                                                            },
                                                            transformOrigin: {
                                                                vertical: "top",
                                                                horizontal: "left"
                                                            }
                                                        }}
                                                    >
                                                        <MenuItem value="">{t("All")}</MenuItem>
                                                        <MenuItem value="assigned">{t("Badge assigned")}</MenuItem>
                                                        <MenuItem value="notAssigned">{t("No badge assigned")}</MenuItem>
                                                        {/* button at bottom of dropdown "scan badge" */}
                                                        <MenuItem
                                                            className={classes.buttonItem}
                                                            disableRipple
                                                            onClick={(e) => e.preventDefault()}
                                                        >
                                                            <button
                                                                className={classes.dropdownButton}
                                                                variant="contained"
                                                                color="primary"
                                                                fullWidth
                                                                onClick={() => setScanningBadge(true)}
                                                            >
                                                                {t("Scan badge")}
                                                            </button>
                                                        </MenuItem>
                                                    </Select>
                                                }
                                                {/* <div className={classes.head__filterInputContainer}>
                                                    <input className={classes.head__filterInput} type="text" value={filterValues[metisUserTableColumns.BADGENUMBER].value} onChange={(e) => handleSearch(e, metisUserTableColumns.BADGENUMBER)} />
                                                    <Search size={16} className={classes.head__filterInputIcon} />
                                                </div> */}
                                            </Collapse>
                                        </TableCell>
                                    </TableRow>

                                    {/* Headers */}
                                    <TableRow key='Metis_Header_row' className={classes.head__headerRow}>
                                        <TableCell className={classes.head__headCell} style={{ width: '8%' }}>
                                            <div className={classes.headCell__contentContainer}>
                                                {t("ID")}
                                                <div className={classes.groupingArrowsContainer}>
                                                    <div className={classes.groupingArrowUpContainer}>
                                                        <ChevronUp size={getGroupingIconSize(metisUserTableColumns.ID, true)} className={classes.groupingArrowUp} style={{ color: getGroupingIconColor(metisUserTableColumns.ID, true) }} onClick={() => handleGrouping(metisUserTableColumns.ID, true)} />
                                                    </div>
                                                    <div className={classes.groupingArrowDownContainer}>
                                                        <ChevronDown size={getGroupingIconSize(metisUserTableColumns.ID, false)} className={classes.groupingArrowDown} style={{ color: getGroupingIconColor(metisUserTableColumns.ID, false) }} onClick={() => handleGrouping(metisUserTableColumns.ID, false)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.head__headCell} style={{ width: '16%' }}>
                                            <div className={classes.headCell__contentContainer}>
                                                {t("Name")}
                                                <div className={classes.groupingArrowsContainer}>
                                                    <div className={classes.groupingArrowUpContainer}>
                                                        <ChevronUp size={getGroupingIconSize(metisUserTableColumns.NAME, true)} className={classes.groupingArrowUp} style={{ color: getGroupingIconColor(metisUserTableColumns.NAME, true) }} onClick={() => handleGrouping(metisUserTableColumns.NAME, true)} />
                                                    </div>
                                                    <div className={classes.groupingArrowDownContainer}>
                                                        <ChevronDown size={getGroupingIconSize(metisUserTableColumns.NAME, false)} className={classes.groupingArrowDown} style={{ color: getGroupingIconColor(metisUserTableColumns.NAME, false) }} onClick={() => handleGrouping(metisUserTableColumns.NAME, false)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </TableCell>
                                        {/* <TableCell className={classes.head__headCell} style={{ width: '30%' }}>
                                            <div className={classes.headCell__contentContainer}>
                                                {t("Email")}
                                                <div className={classes.groupingArrowsContainer}>
                                                    <div className={classes.groupingArrowUpContainer}>
                                                        <ChevronUp size={getGroupingIconSize(metisUserTableColumns.EMAIL, true)} className={classes.groupingArrowUp} style={{ color: getGroupingIconColor(metisUserTableColumns.EMAIL, true) }} onClick={() => handleGrouping(metisUserTableColumns.EMAIL, true)} />
                                                    </div>
                                                    <div className={classes.groupingArrowDownContainer}>
                                                        <ChevronDown size={getGroupingIconSize(metisUserTableColumns.EMAIL, false)} className={classes.groupingArrowDown} style={{ color: getGroupingIconColor(metisUserTableColumns.EMAIL, false) }} onClick={() => handleGrouping(metisUserTableColumns.EMAIL, false)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </TableCell> */}
                                        <TableCell className={classes.head__headCell} style={{ width: '30%' }}>
                                            <div className={classes.headCell__contentContainer}>
                                                {t("Role")}
                                                {/* <div className={classes.groupingArrowsContainer}>
                                                    <div className={classes.groupingArrowUpContainer}>
                                                        <ChevronUp size={getGroupingIconSize(metisUserTableColumns.ROLE, true)} className={classes.groupingArrowUp} style={{ color: getGroupingIconColor(metisUserTableColumns.ROLE, true) }} onClick={() => handleGrouping(metisUserTableColumns.ROLE, true)} />
                                                    </div>
                                                    <div className={classes.groupingArrowDownContainer}>
                                                        <ChevronDown size={getGroupingIconSize(metisUserTableColumns.ROLE, false)} className={classes.groupingArrowDown} style={{ color: getGroupingIconColor(metisUserTableColumns.ROLE, false) }} onClick={() => handleGrouping(metisUserTableColumns.ROLE, false)} />
                                                    </div>
                                                </div> */}
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.head__headCell} style={{ width: '30%' }}>
                                            <div className={classes.headCell__contentContainer}>
                                                {t("Feature")}
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.head__headCell} style={{ width: '16%' }}>
                                            <div className={classes.headCell__contentContainer}>
                                                {t("Badge number")}
                                                <div className={classes.groupingArrowsContainer}>
                                                    <div className={classes.groupingArrowUpContainer}>
                                                        <ChevronUp size={getGroupingIconSize(metisUserTableColumns.BADGENUMBER, true)} className={classes.groupingArrowUp} style={{ color: getGroupingIconColor(metisUserTableColumns.BADGENUMBER, true) }} onClick={() => handleGrouping(metisUserTableColumns.BADGENUMBER, true)} />
                                                    </div>
                                                    <div className={classes.groupingArrowDownContainer}>
                                                        <ChevronDown size={getGroupingIconSize(metisUserTableColumns.BADGENUMBER, false)} className={classes.groupingArrowDown} style={{ color: getGroupingIconColor(metisUserTableColumns.BADGENUMBER, false) }} onClick={() => handleGrouping(metisUserTableColumns.BADGENUMBER, false)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.head__headCell} style={{ width: '44px' }}>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                {props.users.length > 0 ?
                                    <TableBody className={classes.body}>
                                        {filteredUsers.filter(x => x.visible).slice(pg * rpg, pg * rpg + rpg).map((row, index) => (
                                            <>
                                                <TableRow key={index} className={classes.body__row}>
                                                    <TableCell className={classes.body__cell}>{row.Id}</TableCell>
                                                    <TableCell className={classes.body__cell}>{row.Name}</TableCell>
                                                    {/* <TableCell className={classes.body__cell}>{row.email}</TableCell> */}
                                                    <TableCell className={classes.body__cell}>
                                                        <RoleDisplay row={row} />
                                                    </TableCell>
                                                    <TableCell className={classes.body__cell}>
                                                        <FeatureDisplay row={row} />
                                                    </TableCell>
                                                    <TableCell className={classes.body__cell}>
                                                        <div style={{ height: "100%", display: "flex", alignItems: "center" }}>
                                                            {formatBoolean(row.Badgenumber)}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.body__cell}>
                                                        <button onClick={() => handleToggleDropdown(row.Id)} className={classes.body__editCellButton} style={{ backgroundColor: dropdownItem == row.Id ? "#DCDCDC" : "transparent" }}><EllipsisVertical size={20} absoluteStrokeWidth strokeWidth={1.4}></EllipsisVertical></button>
                                                    </TableCell>
                                                    {dropdownItem == row.Id ? <div ref={dropdownRef} className={classes.row__dropdown}>
                                                        <button className={classes.row__dropdownButton} onClick={() => handleEditUser(row)}>{t("Edit")}</button>
                                                        <button className={classes.row__dropdownButton} onClick={() => handleDeleteUser(row)}>{t("Delete")}</button>
                                                    </div> : null}
                                                </TableRow>
                                            </>
                                        ))}
                                    </TableBody>
                                    : null}
                            </Table>
                        </TableContainer>
                        {/* check if filteredUsers that are visible is more then 0 */}
                        {filteredUsers.filter(x => x.visible).length === 0 ?
                            null
                            :
                            <TablePagination
                                rowsPerPageOptions={[25, 50, 100]}
                                component="div"
                                labelRowsPerPage={t("Rows per page")}
                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${t("of")} ${count}`}
                                count={filteredUsers.filter(x => x.visible).length}
                                rowsPerPage={rpg}
                                page={pg}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        }
                    </React.Fragment>
                    {props.users.length === 0 || filteredUsers.filter(x => x.visible).length === 0 ? (
                        <div className={classes.emptyStateContainer}>
                            <p className={classes.emptyState__text}>{t("No users found")}</p>
                        </div>
                    ) : null}
                </div>
            }
            {
                selectedUser && deletingUser &&
                <DeleteDialog selectedUser={selectedUser}  dialogOpen={selectedUser && deletingUser} closeDialog={closeDeleteDialog} deleteUser={deleteUser} />
            }
            {
                selectedUser && editingUser &&
                <MetisUserDialog selectedUser={selectedUser} setUpdatingMetisUsers={props.setUpdatingMetisUsers} updateMetisUserLocally={handleUserUpdate} allUsers={props.users} allUserRoles={props.userRoles} allUserFeatures={props.userFeatures} editing={editingUser} dialogOpen={selectedUser && editingUser} closeDialog={closeEditDialog} />
            }
            {
                scanningBadge &&
                <ScanBadgeDialog dialogOpen={scanningBadge} closeDialog={() => setScanningBadge(false)} handleBadgeNumber={searchScannedBadge} subtitle={t("Scan a badge to find the owner")} />
            }
        </React.Fragment >
    )


}

const useStyles = makeStyles({

    paper: {
        boxShadow: 'none',
        backgroundColor: 'transparent',
    },

    title: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif !important",
        fontWeight: 'medium',
        color: "#020100",
        float: "left",
        marginBottom: "10px",
        paddingLeft: "20px",
        marginTop: "15px"
    },

    head: {

    },

    head__filterRow: {
        height: 'fit-content',
    },

    collapse: {
        float: "left",
        width: "100%",
    },

    head__filterCell: {
        padding: "0px 0px 8px 8px !important",


        "&:first-child": {
            paddingLeft: "14px !important",
        },

        "&:last-child": {
            paddingRight: "8px !important",
        },
    },

    head__filterInputContainer: {
        position: 'relative',
    },

    head__filterInputButton: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        right: '4px',
        border: 'none',
        backgroundColor: 'transparent',
        color: FlagstoneTheme.palette.text.primary,
        cursor: 'pointer',

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        padding: '0px',
        width: '20px',
        height: '20px',
        borderRadius: '4px',

        transition: 'all 0.2s',

        "&:hover": {
            backgroundColor: '#F8F8F8',
            color: '#D84949',
        },
    },

    head__filterInputIcon: {
        color: FlagstoneTheme.palette.text.primary,
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        right: '6px',
    },

    head__fakeFilterInput: {
        width: '100%',
        height: '28px',
        borderRadius: '4px',
        border: 'none',

        display: 'flex',
        alignItems: 'center',

        padding: '0px 8px',
        paddingRight: '28px',
        boxSizing: 'border-box',

        fontSize: '14px',
        fontFamily: 'Lato, sans-serif !important',
        fontWeight: 'regular',
        color: FlagstoneTheme.palette.text.primary,

        backgroundColor: "#FFFFFF",

        "&:focus": {
            outline: "none",
            border: "1px solid #4654FB",
        },
    },

    head__filterInput: {
        width: '100%',
        height: '28px',
        borderRadius: '4px',
        border: 'none',

        display: 'flex',
        alignItems: 'center',

        padding: '0px 8px',
        paddingRight: '28px',
        boxSizing: 'border-box',

        fontSize: '14px',
        fontFamily: 'Lato, sans-serif !important',
        fontWeight: 'regular',
        color: FlagstoneTheme.palette.text.primary,

        backgroundColor: "#FFFFFF",

        "&:focus": {
            outline: "none",
            border: "1px solid #4654FB",
        },
    },

    head__filterSelect: {
        width: '100%',
        height: '28px',
        borderRadius: '4px !important',
        border: 'none !important',

        padding: '0px 8px',
        boxSizing: 'border-box !important',

        fontSize: '14px !important',
        fontFamily: 'Lato, sans-serif !important',
        fontWeight: 'normal !important',
        color: '#0C0E29 !important',

        backgroundColor: 'white',

        "&:focus": {
            outline: "none",
            borderColor: "#4654FB",
        },
    },

    menu: {
        backgroundColor: '#fff',
        borderRadius: "4px",
        marginTop: "8px", // Space between select box and menu
        padding: '4px',
        paddingTop: '4px !important',
        paddingBottom: '4px !important',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)', // Shadow for the dropdown menu

        minWidth: "148px !important",
        width: "fit-content !important",

        '& .MuiMenu-list': {
            padding: 0, // Padding inside the dropdown menu
        },

        '& .MuiMenuItem-root': {
            fontSize: "14px", // Font size for menu items
            color: FlagstoneTheme.palette.text.primary, // Text color for menu items
            padding: '8px 12px', // Padding inside each menu item
            borderRadius: '3px',
            '&:hover': {
                backgroundColor: '#F8F8F8', // Background color on hover
            },
            '&.Mui-selected': {
                backgroundColor: '#e0e0e0', // Background color when selected
                '&:hover': {
                    backgroundColor: '#d5d5d5', // Background color when selected and hovered
                },
            },
        },
    },

    buttonItem: {
        padding: '0px !important', // Adjust padding to match menu items

        '&:hover': {
            backgroundColor: 'transparent !important', // Remove hover background color
        },
    },

    dropdownButton: {
        backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
        color: "white !important",
        fontSize: "14px !important",
        fontFamily: "Lato, sans-serif !important",
        minWidth: "100% !important",
        padding: '8px 16px !important',
        border: 'none !important',
        borderRadius: '3px',

        display: 'flex !important',
        justifyContent: 'center !important',
        alignItems: 'center !important',
        gap: '8px !important',

        marginTop: "8px !important",

        '&:hover': {
            cursor: 'pointer !important',
            backgroundColor: "#3B3AF1 !important",
            color: "white !important",
        },
        '&:disabled': {
            backgroundColor: "lightgrey !important",
            color: "white !important",
            border: "1px solid darkgrey !important",
            cursor: "not-allowed !important"
        },
    },

    head__filterInput_date: {
        width: '100%',
        height: '28px',
        borderRadius: '3px',
        border: '1px solid #A9A9A9',

        padding: '0px 8px',
        boxSizing: 'border-box',

        fontSize: '16px',
        fontFamily: 'Lato, sans-serif !important',
        fontWeight: 'regular',
        color: '#0C0E29',

        "&:focus": {
            outline: "none",
            border: "1px solid #4654FB",
        },
    },

    head__headerRow: {
        backgroundColor: '#E2E4F5',
        borderRadius: "6px",
    },

    head__headCell: {
        fontSize: "16px !important",
        fontFamily: "Lato, sans-serif !important",
        fontWeight: "bold !important",
        color: "#0C0E29",

        padding: "8px 8px !important",
        paddingTop: "0px",
        border: "none",

        "&:first-child": {
            borderRadius: "6px 0 0 6px",
            paddingLeft: "14px !important",
        },

        "&:last-child": {
            borderRadius: "0 6px 6px 0",
            paddingRight: "8px !important",
        },
    },

    headCell__contentContainer: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "8px"
    },

    groupingArrowsContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "0px",
        width: "fit-content"
    },

    groupingArrowUpContainer: {
        position: "relative",
        width: "16px",
        height: "12px",

        "&:hover": {
            cursor: "pointer",

            "& $groupingArrowUp": {
                width: "16px",
                height: "16px",

                transition: "all .1s ease-in",

                color: "#4654FB"
            },
        }
    },

    groupingArrowDownContainer: {
        position: "relative",
        width: "16px",
        height: "12px",

        overflow: "hidden",

        "&:hover": {
            cursor: "pointer",

            "& $groupingArrowDown": {
                width: "16px",
                height: "16px",

                transition: "all .1s ease-in",

                color: "#4654FB"
            },
        }
    },

    groupingArrowUp: {
        position: "absolute",
        bottom: "0%",
        left: "50%",
        transform: "translate(-50%, 0%)",
    },

    groupingArrowDown: {
        position: "absolute",
        top: "0%",
        left: "50%",
        transform: "translate(-50%, 0%)",
    },

    body__row: {
        position: "relative",

        "&:nth-of-type(even)": {
            backgroundColor: "#F7F7F7",
            // mixBlendMode: "multiply",
        },
    },

    body__cell: {
        fontSize: "16px !important",
        fontFamily: "Lato, sans-serif !important",
        fontWeight: "medium",
        color: "#0C0E29",
        padding: "16px 8px !important",

        "&:first-child": {
            borderRadius: "6px 0 0 6px",
            paddingLeft: "14px !important",
        },

        "&:last-child": {
            borderRadius: "0 6px 6px 0",
            paddingRight: "8px !important",
        },
    },

    body__editCellButton: {
        width: "28px",
        height: "28px",
        borderRadius: "4px",
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "0px",
        margin: "0px",
        color: FlagstoneTheme.palette.text.primary,

        transition: "background-color 0.1s",

        "&:hover": {
            backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
            color: FlagstoneTheme.palette.secondary.main,
        }
    },

    row__dropdown: {
        position: "absolute",
        right: "8px",
        top: "48px",

        width: "fit-content",
        height: "fit-content",

        padding: "4px",

        backgroundColor: "white",
        zIndex: "999",
        boxShadow: "0px 3px 15px rgba(175, 175, 175, 0.25)",
        borderRadius: "6px",

    },

    row__dropdownButton: {
        width: "100%",
        height: "32px",
        borderRadius: "4px",
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",

        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "medium",

        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",

        padding: "8px 12px",
        margin: "0px",

        color: FlagstoneTheme.palette.text.primary,

        transition: "background-color 0.1s",

        "&:hover": {
            backgroundColor: "#F8F8F8",
        }
    },

    emptyStateContainer: {
        width: '100%',

        textAlign: "center",
        marginTop: "192px",
    },

    emptyState__text: {
        fontSize: "24px",
        fontFamily: "Lato, sans-serif !important",
        fontWeight: "medium",
        color: "#0C0E29",
    },



    tableContainer: {
        height: "auto",
        overflow: "visible",
        overflowX: "visible !important",
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },
    },
    table: {
        borderSpacing: '0px 5px',
        borderCollapse: 'separate',
    },

    arrowUp: {
        width: "15px",
        marginLeft: "10px",
        position: "relative",
        top: 7,
        cursor: "pointer"
    },
    arrowDown: {
        width: "15px",
        position: "relative",
        top: 7,
        cursor: "pointer"
    },
    loadingBalls: {
        height: '100%',
        display: 'flex',
        // alignContent: 'center',
        // alignItems: 'center',
        justifyContent: 'center',
        marginTop: '144px',
    },
});

function mapStateToProps(state) {
    return {
        workstation: state.workstation,
        general: state.general,
        user: state.user
    }
}

export default connect(mapStateToProps)(MetisUsersOverviewTable)